// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { ShopByIndustryModal } from "@keller/App/Services/ShopByIndustryService";
import { Draft } from "immer";

export interface ShopByIndustryState {
    isLoading: boolean;
    data?: ShopByIndustryModal;
    failedMessage?: string;
}

const initialState: ShopByIndustryState = {
    isLoading: false,
    data: undefined,
    failedMessage: "",
};

const reducer = {
    "xShopByIndustry/BeginLoadShopByIndustry": (draft: Draft<ShopByIndustryState>, action: {}) => {
        draft.isLoading = true;
        draft.failedMessage = "";
    },
    "xShopByIndustry/FailedToLoadShopByIndustry": (
        draft: Draft<ShopByIndustryState>,
        action: { failedMessage: string },
    ) => {
        draft.isLoading = false;
        draft.failedMessage = action.failedMessage;
    },
    "xShopByIndustry/CompleteLoadShopByIndustry": (
        draft: Draft<ShopByIndustryState>,
        action: { data: ShopByIndustryModal },
    ) => {
        draft.isLoading = false;
        draft.data = action.data;
        draft.failedMessage = "";
    },
};

const xShopByIndustry = createTypedReducerWithImmer(initialState, reducer);
(reducers as any).xShopByIndustry = xShopByIndustry;

export type xShopByIndustry = {
    xShopByIndustry: ShopByIndustryState;
} & ApplicationState;
